<template>
  <div class="places">
    <placesList ref="list"></placesList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import placesList from './placesList.vue'

export default {
  components: {
    placesList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.places {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/places/places.vue